import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { refreshScheduler } from '../../../../actions/areas/dailyPlanning/scheduler';
import TreatmentInstanceDialogMoving from '../../../../components/DailyPlanning/TreatmentInstanceDialog/Moving/TreatmentInstanceDialogMoving';
import { updateTreatmentInstance, getTreatmentInstances } from '../../../../actions/entities';

const mapStateToProps = ({
  entities: { treatments, timeSlots },
  areas: {
    dailyPlanning: { availableDatePeriod },
  },
}) => {
  const { isFetching, treatment } = treatments.previewed;
  const { isFetchingTimeSlots, timeSlotPackage } = timeSlots.defaultPackage;

  return {
    isFetching: isFetching || isFetchingTimeSlots,
    treatment,
    defaultTimeSlotPackage: timeSlotPackage,
    occurenceRange: availableDatePeriod,
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  move: async treatment => {
    await dispatch(updateTreatmentInstance(treatment));
    dispatch(getTreatmentInstances(true));
    dispatch(refreshScheduler());
  },
});

const TreatmentInstanceDialogMovingContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentInstanceDialogMoving);

export default TreatmentInstanceDialogMovingContainer;
